module.exports = __webpack_public_path__ + "74b58400613658296e3793ac89c4185d.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-CondBold.woff
 ** module id = 1225
 ** module chunks = 9
 **/